import { z } from 'zod';

export const carrier = z.enum(['verizon', 'simpl', 'kajeet']);
export type Carrier = z.infer<typeof carrier>;

export const simSlot = z.enum(['physical', 'esim']);
export type SimSlot = z.infer<typeof simSlot>;

class Ipv4Cidr {
  private readonly network: number;
  private readonly mask: number;

  constructor(readonly cidr: string) {
    const [address, prefixLength] = cidr.split('/');
    this.mask = Number(prefixLength) === 0 ? 0 : (~0 << (32 - Number(prefixLength))) >>> 0;
    this.network = Ipv4Cidr.applyMask(Ipv4Cidr.toNumber(address), this.mask);
  }

  contains(address: string): boolean {
    return Ipv4Cidr.applyMask(Ipv4Cidr.toNumber(address), this.mask) === this.network;
  }

  private static toNumber(address: string): number {
    return address.split('.').reduce((total, octet) => total * 256 + Number(octet), 0);
  }

  private static applyMask(address: number, mask: number): number {
    return (address & mask) >>> 0;
  }
}

export const CARRIER_ADDRESS_POOLS: Record<Carrier, readonly Ipv4Cidr[]> = {
  verizon: [new Ipv4Cidr('10.40.0.0/16')],
  simpl: [new Ipv4Cidr('10.56.12.0/22')],
  kajeet: [
    new Ipv4Cidr('10.70.0.0/16'),
    new Ipv4Cidr('10.224.0.0/16'),
    new Ipv4Cidr('10.232.0.0/16'),
    new Ipv4Cidr('10.233.0.0/16'),
  ],
};

export function isInCarrierPool(simCarrier: Carrier, ipAddress: string): boolean {
  return CARRIER_ADDRESS_POOLS[simCarrier].some((pool) => pool.contains(ipAddress));
}
